import { Colors } from "@blueprintjs/core";
import React from "react";

export const STAR_SVG_PATH =
    "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z";

const STAR_VIEWBOX = 24;
const STAR_STROKE_WIDTH = 2.5;

type FavoriteStarProps = {
    readonly size: number;
    readonly filled?: boolean;
    readonly className?: string;
    // Map markers draw a white star with a capacity-colored outline, so the
    // gold/currentColor pair and the stroke width can each be overridden.
    readonly fillColor?: string;
    readonly strokeColor?: string;
    readonly strokeWidth?: number;
};

// Filled renders solid Colors.GOLD4; outlined renders
// currentColor, so the consumer sets the muted/disabled tone in SCSS.
const FavoriteStar: React.FC<FavoriteStarProps> = ({
    size,
    filled = false,
    className,
    fillColor,
    strokeColor,
    strokeWidth = STAR_STROKE_WIDTH
}) => (
    <svg
        className={className}
        width={size}
        height={size}
        viewBox={`0 0 ${STAR_VIEWBOX} ${STAR_VIEWBOX}`}
        fill={fillColor ?? (filled ? Colors.GOLD4 : "none")}
        stroke={strokeColor ?? (filled ? Colors.GOLD4 : "currentColor")}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
        style={{ display: "block", overflow: "visible", flex: "0 0 auto" }}
        aria-hidden={true}
    >
        <path d={STAR_SVG_PATH} />
    </svg>
);

export default FavoriteStar;
